import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import ArrowButton from '../common/button-arrow';

class ConfirmPopup extends Component {
  render() {
    return (
      <div className="modal-container">
        <Modal
          show={true}
          container={this}
          aria-labelledby="contained-modal-title">
          <Modal.Header>
            <Modal.Title>{this.props.header}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.props.children}
          </Modal.Body>
          <Modal.Footer>
            <ArrowButton color="grey"
                         className="pull-left"
                         submit={false}
                         arrow={false}
                         disabled={this.props.cancelDisabled}
                         onClick={() => this.props.onClose(false)}>{this.props.cancelLabel}</ArrowButton>

            <ArrowButton color="red"
                         className="pull-right"
                         submit={false}
                         arrow={false}
                         disabled={this.props.confirmDisabled}
                         onClick={() => this.props.onClose(true)}>{this.props.confirmLabel}</ArrowButton>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

ConfirmPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  header: PropTypes.any,
  cancelLabel: PropTypes.string,
  confirmLabel: PropTypes.string,
};

ConfirmPopup.defaultProps = {
  cancelLabel: 'Cancel',
  confirmLabel: 'Confirm',
};

export default ConfirmPopup;



// WEBPACK FOOTER //
// ./src/components/common/confirm-popup.jsx